export const emit = (type, payload) => {
  window.parent.postMessage({ type, payload }, '*');
};
